import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableColumnResizerDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    webStyle
} from "../../../../utils";

export const DATA_TABLE_RESIZE_MAX_RATIO = 8;

export const DATA_TABLE_RESIZE_SHIFT_RATIO = 5;

const stylesheet = StyleSheet.create({
    pan: {
        ...StyleSheet.absoluteFill,
        ...webStyle({
            touchAction: "none"
        })
    },
    container: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        bottom: 0,
        top: 0,
        ...webStyle({
            outlineStyle: "solid",
            cursor: "col-resize",
            touchAction: "none",
            userSelect: "none",
            outlineWidth: 0
        })
    },
    line: {
        pointerEvents: "none",
        height: "100%"
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    isDragging,
    borders,
    colors,
    isLast,
    hit
}: DataTableColumnResizerDynamicStyleType) => {
    const styles = {
        line: {
            backgroundColor: isDragging ? colors.content.border.emphasized : "transparent",
            width: isDragging ? borders.focus : borders.separator
        } as Mutable<ViewStyle>,
        container: {
            zIndex: shapeConfigs.layers.raised,
            end: isLast ? 0 : -hit / 2,
            width: hit,
            ...getFocusRingStyle({
                isFocusVisible,
                borders,
                colors
            })
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
